import React, { useState, useCallback, useMemo } from 'react'
import Dropzone from 'react-dropzone'

const PictureField = ({ files: initialFiles, onChange, getErrors }) => {
  const [files, setFiles] = useState(initialFiles)
  const [disabled, setDisabled] = useState(false)

  const errors = useMemo(() => getErrors(), [getErrors])

  const handleOnDrop = useCallback(acceptedFiles => {
    const newFiles = []

    acceptedFiles.forEach(file => {
      newFiles.push(Object.assign(file, {
        url: URL.createObjectURL(file),
        filename: file.name
      }))
    })
    setFiles(newFiles)
    onChange(acceptedFiles)
  }, [onChange])

  const openFileDialog = useCallback(open => () => {
    setDisabled(true)
    open()
  }, [])

  const handleOnFileDialogOpen = useCallback(() => {
    setDisabled(false)
  }, [])

  const thumbsContainer = {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap'
  }

  const thumb = {
    display: 'inline-flex',
    borderRadius: 2,
    border: '1px solid #eaeaea',
    marginBottom: 8,
    marginRight: 8,
    padding: 4,
    boxSizing: 'border-box'
  }

  const thumbInner = {
    display: 'flex',
    minWidth: 0,
    overflow: 'hidden'
  }

  const img = {
    display: 'block',
    width: '100%',
    maxHeight: '300px'
  }

  const containPicture = files.length > 0

  const defaultCursor = containPicture ? { cursor: 'default' } : {}

  const thumbs = files.map(file => (
    <div style={thumb} key={file.filename}>
      <div style={thumbInner}>
        <img
          src={file.url}
          style={img}
        />
      </div>
    </div>
  ))

  return (
    <Dropzone
      multiple={false}
      accept={{ 'image/*': ['.png', '.jpeg', '.jpg'] }}
      noClick
      noKeyboard
      noPaste
      onDrop={handleOnDrop}
      onFileDialogOpen={handleOnFileDialogOpen}
    >
      {({ getRootProps, getInputProps, open }) => (
        <section className={errors.picture ? 'invalid-dropzone' : ''}>
          <div style={defaultCursor} {...getRootProps({ className: 'dropzone disable' })}>
            <input {...getInputProps()} />
            <aside style={thumbsContainer}>
              {thumbs}
            </aside>
            <button
              className="btn btn-primary"
              type="button"
              disabled={disabled}
              onClick={openFileDialog(open)}
            >
              {containPicture ? 'Modifier' : 'Ajouter une image'}
            </button>
          </div>
          {
            Boolean(errors.picture) &&
            <small className="text-danger">
              {errors.picture[0]}
            </small>
          }
        </section>
      )}
    </Dropzone>
  )
}

export default PictureField
